import React, { Fragment, Suspense } from "react";

import { Routes, Route, Navigate } from "react-router-dom";

//Common
import { PATH_FERRAMENTA_ADM_SYSTEM } from "@/common/constantes";

//Util
import { COMPONENTES } from "@/frontend/utils/registroTelas";
import { fn_getPathTenant, fn_getTelasUsuario } from "@/frontend/utils/sessao";

//Telas
import Home from "@/frontend/pages/home.jsx";
import TLogin from "@/frontend/pages/acesso/login/login.jsx";
import TLogin_system from "./pages/acesso/login/login_system";
import TDashboard from "@/frontend/pages/dashboard/dashboard.jsx";
import TDashboard_system from "@/frontend/pages/system/dashboard_system";
//Geral
import SessaoExpirada from "@/frontend/pages/sessaoExpirada.jsx";
import Manutencao from "@/frontend/pages/manutencao.jsx";
import ServidorIndisponivel from "@/frontend/pages/servidorIndisponivel";
import PageNotFound from "@/frontend/pages/pageNotFound.jsx";
import Incompativel from "@/frontend/pages/incompativel.jsx";
import LayoutPadrao from "@/frontend/pages/layoutPadrao.jsx";

const AppRotas = ({ signed, sessaoUsuario, listTenant }) => {
  const telas = fn_getTelasUsuario(sessaoUsuario);

  const isFerramentaSystem =
    fn_getPathTenant(sessaoUsuario) == PATH_FERRAMENTA_ADM_SYSTEM;

  const renderRotasDinamicas = () => {
    if (!Array.isArray(telas)) {
      return (
        <Fragment>
          <div className="erro">Erro ao buscar as rotas</div>
          {renderRotasPadrao()}
        </Fragment>
      );
    }

    return (
      <Suspense fallback={<div>Carregando...</div>}>
        <Routes>
          <Route element={<LayoutPadrao sessaoUsuario={sessaoUsuario} />}>
            {(isFerramentaSystem && (
              <Route
                key="D"
                path="/dashboard_system"
                element={<TDashboard_system />}
              />
            )) || <Route key="D" path="/dashboard" element={<TDashboard />} />}

            {telas.map((tela) => {
              const Componente = COMPONENTES[tela.componente];
              return (
                <Route
                  key={tela.id}
                  path={tela.rota}
                  element={Componente ? <Componente /> : <PageNotFound />}
                />
              );
            })}

            <Route
              path="/login/*"
              element={
                <Navigate
                  to={isFerramentaSystem ? `/dashboard_system` : `/dashboard`}
                  replace
                />
              }
            />

            <Route path="*" element={<PageNotFound />} />
          </Route>
        </Routes>
      </Suspense>
    );
  };

  const renderRotasPadrao = () => (
    <Routes>
      <Route path="/" element={<Home />} />

      <Route path="/sessao_expirada" element={<SessaoExpirada />} />
      <Route path="/manutencao" element={<Manutencao />} />
      <Route path="/servidor_indisponivel" element={<ServidorIndisponivel />} />

      <Route path="/incompativel" element={<Incompativel />} />

      <Route path="/system/*" element={<Navigate to="/login/system" />} />
      <Route path="/login/system" element={<TLogin_system />} />

      <Route path="/login" element={<Home />} />

      {listTenant.map((tenant, index) => (
        <Fragment key={index}>
          <Route
            key={tenant.path}
            path={`/${tenant.path}/*`}
            element={<Navigate to={`/login/${tenant.path}`} />}
          />
          <Route
            path={`/login/${tenant.path}`}
            element={<TLogin tenant={tenant} />}
          />
        </Fragment>
      ))}
    </Routes>
  );

  return signed && sessaoUsuario ? renderRotasDinamicas() : renderRotasPadrao();
};

export default AppRotas;
